import { render, staticRenderFns } from "./DesignEditTabInformation.vue?vue&type=template&id=11b1617d&"
import script from "./DesignEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./DesignEditTabInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports